<template>
  <v-container>
    <h2 class="header-title">
      Especialidades médicas y sus especialistas
    </h2>
    <p class="header-subtitle grey--text">
      Selecciona una especialidad para ver los médicos disponibles. Explora todo el catálogo y elige
      al que mejor se adapte a tus necesidades.
    </p>
    <!-- <v-subheader class="pa-0">Selecciona una especialidad para ver los médicos a los que puedes acudir.</v-subheader> -->
    <v-row>
      <v-col cols="12" md="6" lg="6" sm="12">
        <select-especialidades-component @value-changed="onChangeEsp" :initialValue="this.select">
        </select-especialidades-component>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="doctor in doctors"
        :key="doctor.idusuario"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card
          class="text-center rounded-lg transition-ease"
          elevation="2"
          hover
        >
          <!-- Imagen -->
          <v-img
            :src="doctor.Imagen || 'https://medicover.mx/img/perfil-medico.png'"
            :alt="'Foto de ' + doctor.Nombre"
            height="140"
            cover
            class="rounded-t-lg"
          />

          <!-- Info -->
          <v-card-text class="pa-4">
            <div class="text-subtitle-1 font-weight-bold">
              {{ doctor.Nombre }}
            </div>
            <div class="text-body-2 text-grey">
              {{ doctor.Especialidad }}
            </div>

            <!-- Rating -->
            <!-- <v-rating
              :model-value="doctor.Rating || 5"
              length="5"
              color="amber"
              half-increments
              size="16"
              density="compact"
              readonly
              class="mt-1"
            /> -->
            <div class="text-caption text-grey">
              ⭐ {{ doctor.Rating || '5.0' }} ({{ doctor.NumConsultas || 0 }})
            </div>

            <!-- Contacto -->
            <div class="mt-3 text-left">
              <div class="text-body-2 my-1">
                <v-icon size="16" color="blue-darken-2" class="mr-1">mdi-phone</v-icon>
                {{ doctor.Tel }}
              </div>
              <div class="text-body-2 my-1">
                <v-icon size="16" color="blue-darken-2" class="mr-1">mdi-hospital-building</v-icon>
                {{ doctor.Consultorio }}
              </div>
              <div class="text-body-2 my-1">
                <v-icon size="16" color="blue-darken-2" class="mr-1">mdi-map-marker</v-icon>
                {{ doctor.Direccion }}
              </div>
            </div>
          </v-card-text>
      <!-- Botones siempre fijos abajo -->
          <v-card-actions
            class="pa-3 pt-0 d-flex flex-wrap justify-center"
            style="flex-shrink: 0;"
          >
          <v-btn
            small
            color="green darken-2"
            dark
            :href="'tel:' + doctor.Tel"
            prepend-icon="mdi-phone"
            class="flex-grow-1"
            elevation="4"
            rounded
            ripple
          >
            Llamar
          </v-btn>
          <v-btn
            small
            color="blue darken-2"
            dark
            :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(doctor.Direccion)}`"
            target="_blank"
            prepend-icon="mdi-map-marker"
            class="flex-grow-1"
            elevation="4"
            rounded
            ripple
          >
            Mapa
          </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SelectEspecialidadesComponent from "@/components/selectEspecialidades.vue";

export default {
  metaInfo: {
    title: 'Medicover - Especialidades médicas',
    meta: [
      {
        name: 'description',
        content: 'Descubre nuestro catálogo médico con los especialistas más destacados, listos para cuidar de tu salud y bienestar.'
      }
    ]
  },
  components: {
    SelectEspecialidadesComponent
  },
  methods: {
    handleRowClick(item) {
      if (window.getSelection().toString().length === 0) {
        // console.log(JSON.parse(localStorage.getItem('permisos')))
        this.nombredoctor = item.nombre + ' ' + item.apaterno + ' ' + item.amaterno
        this.telefono = item.tels // Use router.push here
        this.$swal({
          // position: 'top-end',
          title: 'Doctor',
          // input: 'text',
          icon: 'phone',
          html:
            '<b>' + this.nombredoctor + '</b>,<br/>' +
            '<br/><a href="tel:' + this.telefono + '"><h2 style="color:blue">Llamar</h2></a><br/> ',
          confirmButtonText: 'Cerrar',
          showCloseButton: true,
          showConfirmButton: true,
          closeButtonText: 'cerrar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6'
          // timer: 1500,
        }).then((data) => {
          console.log(data)
        })
      }
    },
    llamando(telefono) {
      this.telefono = telefono // Use router.push here
      window.location.href = 'tel:' + telefono
      // window.open('tel:' + telefono)
    },
    onBusca(value) {
      console.log(value)
    },
    onChangeEsp(event) {
      console.log(event)
      this.idespecialidad = event
      this.getDoctors()
    },
    onChangePago(event) {
      this.pagos = event.num
      this.Calculos()
    },
    async onChangeCheck() {
      this.getDoctors()
    },
    async getDoctors() {
      if (this.idespecialidad !== '') {
          this.$http.get(`medico/especialidad?Id=${this.idespecialidad}`) 
            .then(response => {
              if (response.status === 200) {
                this.doctors = response.data
              }
            })
            .catch(() => {
            });
      }
    }
  },
  data() {
    return {
      rating: 5,
      nombredoctor: '',
      telefono: '',
      ancho: window.innerWidth,
      largo: window.innerHeigth,
      name: 'Cotizador',
      title: 'Cotizador',
      select: '',
      // select: { nombre: 'Plan', consultas: '0' },
      pagodefault: { num: 1, nombre: 'ANUAL' },
      items: [],
      search: '',
      doctors: [],
      headersdoctors: [
        {
          text: 'Nombres',
          align: 'start',
          filterable: false,
          value: 'nombre'
        },
        { text: 'Apellido', value: 'apaterno' },
        { text: 'Apellido', value: 'amaterno' },
        { text: 'Correo', value: 'mail' },
        { text: 'Dirección', value: 'direccion' },
        { text: 'Teléfono', value: 'tels' }
      ],
      idespecialidad: '',
    }
  }
}
</script>
<style lang="scss"></style>
